import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "subcategories", "subcategory"]

  connect() {
    this.activeCategory = this.linkTargets.find(link => link.classList.contains("bg-grey-500", "bg-opacity-20", "text-grey-900"))
    this.activeSubcategories = null
    this.linkTargets.forEach(link => {
      link.addEventListener("mouseover", this.showSubcategories.bind(this))
    })
  }

  showSubcategories(event) {
    const categoryId = event.target.dataset.categoryId

    if (this.activeCategory) {
      this.activeCategory.classList.remove("bg-grey-500", "bg-opacity-20", "text-grey-900")
    }

    if (this.activeSubcategories) {
      this.activeSubcategories.classList.add("hidden")
    }

    event.target.classList.add("bg-grey-500", "bg-opacity-20", "text-grey-900")
    this.activeCategory = event.target

    const subcategories = this.subcategoryTargets.find(subcategory => subcategory.dataset.categoryId === categoryId)
    if (subcategories) {
      subcategories.classList.remove("hidden")
      this.activeSubcategories = subcategories
    }
  }
}
